import { render, staticRenderFns } from "./authenticationResendCountdown.vue?vue&type=template&id=2781fcdf"
import script from "./authenticationResendCountdown.vue?vue&type=script&lang=js"
export * from "./authenticationResendCountdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports